<template>
  <div>
    <div class="searchContainer">
      <Search ref="Search" @on-change="onSearch($event)" @on-result-key="onSearch($event)"  :placeholder="$t('kol.header.search')" :cancel-text="$t('kol.header.cancel')" class="stickToTop">
        <template slot="left">
          <span  class="regionText" @click="showRegionMenu = true">{{$t('kol.region.region')}}</span>
        </template>
      </Search>
      <!-- Region Selection Sheet -->
      <Actionsheet v-model="showRegionMenu" :menus="menus" @on-click-menu="clickedAction">
        <template slot="header">
          <h5 >{{$t('kol.region.selectText')}}</h5>
          <h5 v-if="currentRegion" class="currentRegionText">{{$t('kol.region.currentOption')+': '+$t(`kol.region.${this.currentRegion}`)}}</h5>
        </template>
      </Actionsheet>
    </div>
  </div>
</template>
<script>
  import { Search } from 'vux'
import { Actionsheet } from 'vux'
import Vue from 'vue'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex';
const localeStrings = {
  en_us: "English",
  zh_cn: "简体中文",
  zh_hk: "正體中文"
}

export default {
  name: 'SearchBar',
  components: {
    Search,
    Actionsheet
  },
  data() {
    return {
      showRegionMenu:false,
      currentRegion:'hk',
      menus: [
      // {
      //   label: this.$t('kol.region.cn'),
      //   type:'default',
      //   value:'cn'
      // },
      {
        label: this.$t('kol.region.hk'),
        type:'default',
        value:'hk'

      },
      {
        label: this.$t('kol.region.mo'),
        type:'default',
        value:'mo'
      },
      ],
    }
  },
  created(){
    let langs = Cookies.get('locale');
    let region = Cookies.get('region');
    if(region){
      this.currentRegion = region;
    }
    if(!langs){
    this.clickedAction(this.currentRegion);
  }
  },
  computed:{
    ...mapGetters([
      'getRouteStatus'
    ]),
    currentRegionLabel(){ 
      return this.$t('kol.region.'+this.currentRegion);
    },
    currentRoute() {
      return this.$router.currentRoute;
    },
  },
  methods: {
    clickedAction($event){
        let lang = $event;
       this.currentRegion = lang;
       // if(lang == 'cn'){
       //    this.setLocale('zh_cn');
       // }else{
       //    this.setLocale('zh_hk');
       // }
      this.setLocale(`zh_${lang}`);
      this.$store.dispatch('clearShoppingCart');
    },
     setLocale(locale){
      Vue.config.lang = locale
      Cookies.set('locale', locale)
      Cookies.set('region', this.currentRegion);
      this.$i18n.locale = Vue.config.lang
      let param1 = {}
      if(Cookies.get('region')){
        param1.region = Cookies.get('region')
      }
      else{
        param1.region = 'hk'
      }
      let param = {
        count: this.count,
        orderby: 'ID',
        loadGroupBuy:1,
        ...param1
      };
      switch(this.getRouteStatus.module){
        case 'Product':
          // Hardcode for Exhibition
          this.$store.dispatch('Product/getFullProductList', param).then((json) => {

            })
            .catch((error) => {
              switch (error.status) {
                case 401:
                case 403:
                  this.$router.push('/login?type=1');
                  break;
              }
            });
          break;
        case 'Shop':
          let link = this.currentRoute.query.link;
          param['link'] = link;
          this.$store.dispatch('Shop/getKOLProducts', param);
          break;
      }
      // console.log("New locale = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])
    },
    onSearch(search){
      this.$store.commit('setSearchString',{search:search});
    },
    // onSubmit(search){
    //   this.$refs.Search.setBlur();
    //   this.onSearch(search);
    // }
  } 
}

</script>
<style type="text/css">
.searchContainer {
  height: 44px;
  background: #EFEFF4;
}

.regionText {
  font-size: 14px;
  padding-right: 10px;
  margin-top: 2px;
}
.currentRegionText{
  font-size: 14px;
  color:#aaa;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/SearchBar.vue